// cr 遮罩元件
// import ReactPlayer from 'react-player';
"use client"

const CRMask = () =>{
    return(
        <div className="mask-wrap mask w-full h-full overflow-hidden">
            <video loop muted playsInline autoPlay
                className="cr-video w-full h-full"
                width={100}
            >
                 <source src="/images/cryptoread/video/bg_video.mp4" type="video/mp4" />
            </video>
        </div>
    )
};

export default CRMask;